// ═══════════════════════════════════════════════════════════════
// VoteConfig.js — Vote Mode constants and helpers
// ═══════════════════════════════════════════════════════════════

const VOTE_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
};

const VOTE_RATING_LABELS = {
  1: 'Strongly Oppose',
  2: 'Oppose',
  3: 'Neutral',
  4: 'Support',
  5: 'Strongly Support',
};

const MAX_OPTIONS = 10;
const MAX_PARTICIPANTS = 6;
const MIN_OPTIONS = 2;

function generateVoteId() {
  return `vote-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function generateShareCode() {
  return Math.random().toString(36).slice(2, 10).toUpperCase();
}

function computeResults(vote) {
  if (!vote?.options || !vote?.ratings) return [];

  const results = vote.options.map((option) => {
    const optionRatings = Object.values(vote.ratings)
      .map((r) => r[option.id])
      .filter((r) => r != null);

    const total = optionRatings.reduce((sum, r) => sum + r, 0);
    const avg = optionRatings.length > 0 ? total / optionRatings.length : 0;

    return {
      id: option.id,
      label: option.label,
      average: Math.round(avg * 100) / 100,
      voteCount: optionRatings.length,
      ratings: optionRatings,
    };
  });

  return results.sort((a, b) => b.average - a.average);
}

export {
  VOTE_STATUS,
  VOTE_RATING_LABELS,
  MAX_OPTIONS,
  MAX_PARTICIPANTS,
  MIN_OPTIONS,
  generateVoteId,
  generateShareCode,
  computeResults,
};
